import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import BarDetailsContainer from "./containers/BarDetails/BarDetails.container";
import CustomerDetailsContainer from "./containers/CustomerDetails/CustomerDetails.container";
import DashboardContainer from "./containers/Dashboard/Dashboard.container";
import LoginContainer from "./containers/Login/Login.container";
import ManageBarContainer from "./containers/ManageBar/ManageBar.container";
import AuthContextProvider from "./contexts/auth.context";
import ConfirmContextProvider from "./contexts/confirm.context";

const darkTheme = createMuiTheme({
  props: {
    MuiTypography: {
      variantMapping: {
        h1: "h2",
        h2: "h2",
        h3: "h2",
        h4: "h2",
        h5: "h2",
        h6: "h2",
        subtitle1: "h2",
        subtitle2: "h2",
        body1: "span",
        body2: "span",
      },
    },
  },
  palette: {
    type: "dark",
    primary: {
      main: "#DFAF00",
    },
    secondary: {
      main: "#9B7D07",
    },
    success: {
      main: "#28C94D",
    },
    warning: {
      main: "#F40C1A",
    },
  },
});

function App() {
  return (
    <Router>
      <ThemeProvider theme={darkTheme}>
        <AuthContextProvider>
          <ConfirmContextProvider>
            <Switch>
              <Route path="/login" component={LoginContainer} />
              {/* Bars/customers list */}
              <Route path="/dashboard" component={DashboardContainer} />
              {/* Bar details */}
              <Route path="/bar-details/:id" component={BarDetailsContainer} />
              {/* Bar create/edit form */}
              <Route path="/manage-bar/:id" component={ManageBarContainer} />
              <Route path="/manage-bar" component={ManageBarContainer} />
              {/* Customer details */}
              <Route
                path="/customer-details/:id"
                component={CustomerDetailsContainer}
              />
              <Redirect path="/" to="/dashboard" exact />
            </Switch>
          </ConfirmContextProvider>
        </AuthContextProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
